import axios from "axios";
import axiosInstance from "@/services/https/global";
import CONFIG from "../config";

const baseUrl = `${CONFIG.BASE_URL}/audit-reporting/api/v1`;

export const getActivity = async ({ id }) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/activity-logs/${id}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getActivityLogs = async (params = {}) => {
  const queryParams = {};

  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();

  try {
    const response = await axiosInstance.get(`${baseUrl}/activity-logs`, {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};
